import * as React from 'react';

interface SubcontentProps {
  subContent: React.ReactNode | null;
  classes: Record<string, string>;
}
export const SubContent: React.FC<SubcontentProps> = ({ subContent, classes }) =>
  subContent !== null ? <div className={classes.subContent}>{subContent}</div> : null;
